import React from "react";
import { Pagination } from "react-bootstrap";

const DynamicPagination = ({ totalPages, currentPage, onPageChange }) => {
  const pageItems = [];
  // const pageShow = currentPage > 7 ? 4 : 12 - currentPage; // how many pages to show on each side of current
  const pageShow = currentPage > 3 ? 2 : 3; // how many pages to show on each side of current

  const startPage = Math.max(2, currentPage - pageShow);

  const endPage = Math.min(totalPages - 1, currentPage + pageShow);
  // Always show First page
  pageItems.push(
    <Pagination.Item
      key={1}
      active={currentPage === 1}
      onClick={() => onPageChange(1)}
    >
      {1}
    </Pagination.Item>
  );

  // Ellipsis before startPage
  if (startPage > 2) {
    pageItems.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
  }

  // Middle page range
  for (let page = startPage; page <= endPage; page++) {
    pageItems.push(
      <Pagination.Item
        key={page}
        active={page === currentPage}
        onClick={() => onPageChange(page)}
      >
        {page}
      </Pagination.Item>
    );
  }

  // Ellipsis after endPage
  if (endPage < totalPages - 1) {
    pageItems.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
  }
  // Always show Last page
  if (totalPages > 1) {
    pageItems.push(
      <Pagination.Item
        key={totalPages}
        active={currentPage === totalPages}
        onClick={() => onPageChange(totalPages)}
      >
        {totalPages}
      </Pagination.Item>
    );
  }

  return (
    <Pagination>
      <Pagination.First
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
      />
      <Pagination.Prev
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />
      {pageItems}
      <Pagination.Next
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      />
      <Pagination.Last
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
      />
    </Pagination>
  );
};

export default DynamicPagination;
